import { useMemo } from 'react';
import { useCommon } from 'redux/common/use-common';

export const useDynamicApi = (apiClass) => {
  const { currentRestaurant } = useCommon();

  const api = useMemo(() => {
    return new apiClass(currentRestaurant?.id);
  }, [currentRestaurant]);

  return { api, currentRestaurant };
};
